import React from 'react'
import { Container, ComboBox, Label } from '@sencha/ext-modern'

const beepSound = new Audio('./resources/beep.mp3')
//ios不能自动播放，先播放，后暂停，之后的播放就没问题了
function initBeep() {
	beepSound.play()
	beepSound.pause()
}

function beep() {
	beepSound.play()
}

class LiveScanDlg extends React.Component {
	currentStream
	ZXing = null
	decodePtr = null
	state = {
		devices: [],
		deviceId: null
	}
	Module = {
		onRuntimeInitialized: function (_this) {
			_this.ZXing = Module
			_this.decodePtr = _this.ZXing.Runtime.addFunction(_this.decodeCallback)
		}
	}
	video = document.getElementById('video')

	decodeCallback = (ptr, len, resultIndex, resultCount) => {
		const { onScanned, onClose } = this.props
		beep()
		var result = new Uint8Array(this.ZXing.HEAPU8.buffer, ptr, len)
		var data = String.fromCharCode.apply(null, result)
		//console.log(data)
		onScanned && onScanned(data)
		onClose && onClose()
	}

	componentDidMount() {
		this.Module.onRuntimeInitialized(this)
		// navigator.mediaDevices.enumerateDevices().then(this.gotDevices)
		this.gotVideo()
	}

	componentWillUnmount() {
		if (typeof this.currentStream !== 'undefined') {
			this.stopMediaTracks(this.currentStream)
		}
	}

	stopMediaTracks = (stream) => {
		stream.getTracks().forEach(track => {
			track.stop()
		})
	}

	gotDevices = (mediaDevices) => {
		var _devices = []
		mediaDevices.forEach(mediaDevice => {
			if (mediaDevice.kind.match(/^video.*/))
				_devices.push(mediaDevice)
		})
		this.setState({ devices: _devices })
	}

	gotVideo = (deviceId) => {
		const { onClose = () => { } } = this.props
		const { devices } = this.state
		if (typeof this.currentStream !== 'undefined') {
			this.stopMediaTracks(this.currentStream)
		}

		if (!navigator.mediaDevices) {
			onClose()
			Tyan.pubForm.showError("没有可用的摄像头，请检查设备或与管理员联系!")
			return
		}
		const videoConstraints = {}
		if (!deviceId)
			videoConstraints.facingMode = 'environment'
		else
			videoConstraints.deviceId = { exact: deviceId }
		const constraints = {
			video: videoConstraints,
			audio: false
		}

		navigator.mediaDevices
			.getUserMedia(constraints)
			.then(stream => {
				this.currentStream = stream
				video.srcObject = stream
				this.scanBarcode()
				return navigator.mediaDevices.enumerateDevices()
			})
			.then(devices.length == 0 && this.gotDevices)
			.catch(error => {
				onClose()
				Tyan.pubForm.showError(error.toString().includes("Permission") ? '没有使用摄像头的权限，请检查浏览器设置！' : error)
				console.error(error)
			})
	}

	// scan barcode
	scanBarcode = () => {
		if (this.ZXing == null) {
			alert("Barcode Reader is not ready!")
			return
		}
		if (typeof video == 'undefined') return

		//console.log("video width: " + video.offsetWidth + ", height: " + video.offsetHeight)
		var barcodeCanvas = document.createElement("canvas")
		barcodeCanvas.width = video.offsetWidth
		barcodeCanvas.height = video.offsetHeight
		var barcodeContext = barcodeCanvas.getContext('2d')
		var imageWidth = video.offsetWidth, imageHeight = video.offsetHeight
		barcodeContext.drawImage(video, 0, 0, imageWidth, imageHeight)
		// read barcode
		var imageData = barcodeContext.getImageData(0, 0, imageWidth, imageHeight)
		var idd = imageData.data
		var image = this.ZXing._resize(imageWidth, imageHeight)
		//console.time("decode barcode")
		for (var i = 0, j = 0; i < idd.length; i += 4, j++) {
			this.ZXing.HEAPU8[image + j] = idd[i]
		}
		var err = this.ZXing._decode_any(this.decodePtr)
		//console.timeEnd('decode barcode')
		//console.log("error code", err)
		if (err == -2) {
			setTimeout(this.scanBarcode, 30)
		}
	}

	handleChange = (v) => {
		this.gotVideo(v._value)
		this.setState({ deviceId: v._value })
	}

	render() {
		const { deviceId, devices } = this.state
		return <Container margin='0 20 20 20' {...this.props}>
			{devices.length > 0 && <Container layout={{ type: "hbox", pack: "start" }} >
				<Label html='摄像头：' style={{ marginTop: '8px' }} />
				<ComboBox queryMode='local' onChange={this.handleChange} editable={false} value={deviceId ? deviceId : devices[devices.length - 1].deviceId}
					options={devices.map(o => [o.deviceId, o.label])} />
			</Container>}
			<div><video id="video" autoPlay playsInline></video></div>
		</Container>
	}
}

// 动态装载resources/zxing.js
const ZXLOADING = 1
const ZXLOADED = 2
const ZXERROR = 3
const ZXNONE = 0
var zxStatus = ZXNONE;
; (() => {
	zxStatus = ZXLOADING
	var jsNode = document.createElement('script');
	jsNode.setAttribute('type', 'text/javascript');
	jsNode.setAttribute('id', 'scriptzxing')
	jsNode.setAttribute('src', 'resources/zxing.js');

	jsNode.onload = () => zxStatus = ZXLOADED
	jsNode.onerror = (e) => zxStatus = ZXERROR
	// // ie6, ie7不支持onload的情况
	// jsNode.onreadystatechange = function () {
	// 	if (jsNode.readyState == 'loaded' || jsNode.readyState == 'complete') {
	// 		// 异步js加载完毕
	// 		// do something执行操作
	// 	}
	// }
	document.body.appendChild(jsNode);
})()


const handleScan = (scanProps) => {
	if (zxStatus != ZXLOADED) {
		zxStatus == ZXERROR && Ext.toast('扫描组件装载失败，扫描功能暂时不能使用，请与系统管理员联系!')
		zxStatus == ZXLOADING && Ext.toast('扫描组件正在装载中，请稍后再试！')
		zxStatus == ZXNONE && Ext.toast('扫描组件尚未加载')
		return
	}
	if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent))
		initBeep()
	Tyan.pubForm.showDialog('扫一扫', LiveScanDlg, scanProps, { closable: true, closeAction: 'hide' })
}

export default handleScan
